import React from 'react';

import Icon from 'components/Misc/Icon';

const Step = ({ icon, active, action, disabled, onChange }) => {
	// Pass current action to parent's function
	const onClick = () => onChange({ name: 'page', value: action === 'prev' ? active - 1 : active + 1 });

	return (
		<button
			className="w-9 h-9 disabled:text-neutral-400 dark:disabled:text-neutral-700 text-neutral-600 hover:text-neutral-800 hover:bg-neutral-100 dark:text-neutral-400 dark:hover:bg-neutral-700 rounded-lg transition-colors"
			onClick={onClick}
			disabled={disabled}
		>
			<Icon icon={icon} />
		</button>
	);
};

export default Step;
